type TreeNode = {
  value: any;
  children?: TreeNode[];
};

export function findPathInTree(tree: TreeNode[], targetValue: any) {
  // 用于存储待遍历的节点和对应的路径
  const stack: { node: TreeNode; path: any[] }[] = [
    { node: { value: null, children: tree }, path: [] },
  ];

  while (stack.length > 0) {
    // 从栈中取出当前待处理的节点和路径
    const { node, path } = stack.pop();

    // 如果节点有子节点，将子节点及其路径压入栈中
    if (node.children) {
      for (let i = node.children.length - 1; i >= 0; i--) {
        const child = node.children[i];
        const newPath = [...path, child.value];
        stack.push({ node: child, path: newPath });
      }
    } else {
      // 检查当前节点的 value 是否为目标值
      if (node.value === targetValue) {
        return path;
      }
    }
  }

  // 未找到目标节点，返回 null
  return null;
}
